module.exports = __webpack_public_path__ + "static/media/itsSuchADrag.daf78f92.jpg";